import {mw} from 'mw/MW';

import {ChromeCastPlayerModule} from './ChromeCastPlayerModule';
import {WebPlayerModule} from './web-native-player/WebPlayerModule';

export const getPlayerModule = () => {
  return mw.options.isChromeCast ? ChromeCastPlayerModule.INSTANCE : WebPlayerModule.getInstance();
};
